import { Blankslate, SecondaryAction, PrimaryAction, Description, Heading, Visual } from './Blankslate.js';

const BlankslateContainer = Object.assign(Blankslate, {
  Visual,
  Heading,
  Description,
  PrimaryAction,
  SecondaryAction
});

export { BlankslateContainer as Blankslate };
